import styled from '@emotion/styled/macro'
import { Flex, FlexProps } from '@rebass/grid/emotion'
import { Throw } from 'components/Throw'
import { Spinner, SpinnerSize } from 'office-ui-fabric-react'
import * as React from 'react'

const Container = styled(Flex)`
  height: calc(100vh - 50px);
`

export type FlexSpinnerProps = FlexProps & {
  label?: string
  labelPosition?: 'top' | 'right' | 'bottom' | 'left'
  children?: React.ReactNode
  loading?: boolean
  error?: any
}
export const FlexSpinner = ({
  label,
  labelPosition = 'bottom',
  children,
  loading,
  error,
  ...props
}: FlexSpinnerProps) => {
  if (error) {
    return <Throw err={error} />
  }
  if (loading) {
    return (
      <Container
        align="center"
        justify="center"
        flexDirection="column"
        justifyContent="center"
        {...(props as any)}
      >
        <Spinner
          size={SpinnerSize.large}
          label={label}
          labelPosition={labelPosition}
          style={{
            fontFamily:
              "'Segoe UI', 'Segoe UI Web (West European)', 'Segoe UI', -apple-system, BlinkMacSystemFont, 'Roboto', 'Helvetica Neue', sans-serif",
            fontSize: 22,
          }}
        />
      </Container>
    )
  }
  return <>{children}</>
}

export default FlexSpinner
